const AUTO_OPEN_CLASS = "fs-ambassadors--auto-opening";
const AUTO_OPEN_TIMEOUT_MS = 6000;
const MATCH_SETTLE_MS = 600;
const POLL_MS = 100;

interface FsAmbassadorsResponse {
  results?: { gallery: number; thumbnail_id: number }[];
}

let coverPostIds: Promise<Map<string, string>> | null = null;

function fetchCoverPostIds(feedId: string): Promise<Map<string, string>> {
  coverPostIds ??= fetch(
    `https://foursixty.com/api/v2/${encodeURIComponent(feedId)}/ambassadors?page_size=1000`,
  )
    .then((response) => {
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return response.json() as Promise<FsAmbassadorsResponse>;
    })
    .then(
      (data) =>
        new Map(
          (data.results ?? []).map(({ gallery, thumbnail_id: postId }) => [
            String(gallery),
            String(postId),
          ]),
        ),
    )
    .catch(() => {
      coverPostIds = null;
      return new Map<string, string>();
    });
  return coverPostIds;
}

function initAmbassadorsClickThrough(root: HTMLElement): void {
  let cancelPending: (() => void) | null = null;

  const stop = (): void => {
    cancelPending?.();
    cancelPending = null;
    root.classList.remove(AUTO_OPEN_CLASS);
  };

  root.addEventListener(
    "click",
    (event) => {
      const post = (event.target as Element | null)?.closest(
        ".fs-container--collage .fs-ambassador__post",
      );
      if (!post || !root.contains(post)) return;

      const feed = root.querySelector<HTMLElement>(".fs-ambassadors__feed");
      if (!feed) return;

      stop();

      const galleryId =
        post.closest(".fs-ambassador")?.getAttribute("data-gallery") || null;

      const staleIds = new Set(
        Array.from(
          feed.querySelectorAll<HTMLElement>(".fs-timeline-entry"),
          (entry) => entry.id,
        ),
      );

      root.classList.add(AUTO_OPEN_CLASS);

      const startedAt = Date.now();
      let entriesSeenAt = 0;
      let clicked = false;
      let coverId: string | null = null;
      let lookupStarted = !galleryId;
      let lookupDone = !galleryId;

      const timer = window.setInterval(() => {
        if (Date.now() - startedAt > AUTO_OPEN_TIMEOUT_MS) {
          stop();
          return;
        }

        if (clicked) {
          if (document.querySelector(".fs-timeline-detail:not(.fs-hidden)")) {
            stop();
          }
          return;
        }

        if (!lookupStarted) {
          const feedId = root
            .querySelector("#fs-ambassadors-embed")
            ?.getAttribute("data-feed-id");
          if (feedId) {
            lookupStarted = true;
            void fetchCoverPostIds(feedId).then((covers) => {
              coverId = (galleryId && covers.get(galleryId)) || null;
              lookupDone = true;
            });
          }
        }

        const entries = Array.from(
          feed.querySelectorAll<HTMLElement>(".fs-timeline-entry"),
        ).filter((entry) => !staleIds.has(entry.id));
        if (entries.length === 0) return;
        if (!entriesSeenAt) entriesSeenAt = Date.now();

        const match = coverId
          ? entries.find((entry) => entry.id.endsWith(`-${coverId}`))
          : undefined;

        if (match) {
          match.click();
          clicked = true;
          return;
        }

        if (lookupDone && Date.now() - entriesSeenAt >= MATCH_SETTLE_MS) {
          stop();
        }
      }, POLL_MS);

      cancelPending = () => window.clearInterval(timer);
    },
    true,
  );
}

function boot(): void {
  const root = document.getElementById("fs-ambassadors");
  if (root) initAmbassadorsClickThrough(root);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}
